"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileBootstrapResponseSchema = exports.mobileBusinessAccessSchema = exports.workspaceAccessListResponseSchema = exports.workspaceAccessSchema = exports.currentBusinessContextResponseSchema = exports.businessContextSchema = exports.operationalLocationListResponseSchema = exports.operationalLocationSchema = exports.updateOperationalLocationRequestSchema = exports.createOperationalLocationRequestSchema = exports.operationalLocationInputSchema = exports.businessSettingsSchema = exports.updateBusinessSettingsRequestSchema = exports.onboardBusinessRequestSchema = exports.operationalLocationAccessSchema = exports.operationalLocationStatusSchema = exports.operationalLocationIdSchema = exports.businessIdSchema = exports.mobileStaffPermissionSchema = exports.MOBILE_STAFF_PERMISSIONS = exports.membershipRoleSchema = void 0;
const zod_1 = require("zod");
const staff_capability_1 = require("./staff-capability");
exports.membershipRoleSchema = zod_1.z.enum([
    "OWNER",
    "ADMIN",
    "DISPATCHER",
    "TECHNICIAN",
]);
exports.MOBILE_STAFF_PERMISSIONS = [
    "jobs:read",
    "jobs:write",
    "schedule:read",
    "schedule:write",
    "notifications:read",
    "business:manage",
    "team:manage",
];
exports.mobileStaffPermissionSchema = zod_1.z.enum(exports.MOBILE_STAFF_PERMISSIONS);
const optionalTrimmedString = (maxLength) => zod_1.z
    .string()
    .trim()
    .max(maxLength)
    .optional()
    .transform((value) => value || undefined);
const timeZoneSchema = zod_1.z.string().trim().refine(isValidTimeZone, {
    message: "A valid IANA timezone is required.",
});
const nullableTrimmedString = (maxLength) => zod_1.z
    .union([zod_1.z.string().trim().max(maxLength), zod_1.z.null()])
    .transform((value) => value || null);
const nullableEmailSchema = zod_1.z
    .union([zod_1.z.string().trim().email().max(320), zod_1.z.null()])
    .transform((value) => value || null);
const nullablePhoneSchema = zod_1.z
    .union([
    zod_1.z
        .string()
        .trim()
        .regex(/^\+[1-9]\d{7,14}$/, "Phone must use E.164 format."),
    zod_1.z.null(),
])
    .transform((value) => value || null);
const nullableUrlSchema = zod_1.z
    .union([zod_1.z.string().trim().url().max(2_048), zod_1.z.null()])
    .transform((value) => value || null);
exports.businessIdSchema = zod_1.z.string().uuid();
exports.operationalLocationIdSchema = zod_1.z.string().uuid();
exports.operationalLocationStatusSchema = zod_1.z.enum(["ACTIVE", "ARCHIVED"]);
exports.operationalLocationAccessSchema = zod_1.z.object({
    id: exports.operationalLocationIdSchema,
    name: zod_1.z.string().min(1).max(120),
    timezone: timeZoneSchema,
    status: exports.operationalLocationStatusSchema,
    isDefault: zod_1.z.boolean(),
});
exports.onboardBusinessRequestSchema = zod_1.z.object({
    business: zod_1.z.object({
        name: zod_1.z.string().trim().min(2).max(120),
        legalName: optionalTrimmedString(160),
        contactEmail: zod_1.z
            .string()
            .trim()
            .email()
            .max(320)
            .optional()
            .transform((value) => value || undefined),
        phone: zod_1.z
            .string()
            .trim()
            .regex(/^\+[1-9]\d{7,14}$/, "Phone must use E.164 format.")
            .optional()
            .transform((value) => value || undefined),
    }),
    location: zod_1.z.object({
        name: zod_1.z.string().trim().min(2).max(120),
        addressLine1: zod_1.z.string().trim().min(3).max(160),
        addressLine2: optionalTrimmedString(160),
        city: zod_1.z.string().trim().min(2).max(100),
        state: zod_1.z
            .string()
            .trim()
            .transform((value) => value.toUpperCase())
            .pipe(zod_1.z.string().regex(/^[A-Z]{2}$/, "Use a two-letter US state code.")),
        postalCode: zod_1.z
            .string()
            .trim()
            .regex(/^\d{5}(?:-\d{4})?$/, "Use a valid US ZIP code."),
        timezone: timeZoneSchema,
    }),
});
exports.updateBusinessSettingsRequestSchema = zod_1.z.object({
    displayName: zod_1.z.string().trim().min(2).max(120),
    legalName: nullableTrimmedString(160),
    contactEmail: nullableEmailSchema,
    phone: nullablePhoneSchema,
    logoUrl: nullableUrlSchema,
    websiteUrl: nullableUrlSchema,
    currency: zod_1.z.literal("USD"),
    defaultTimezone: timeZoneSchema,
    multiLocationEnabled: zod_1.z.boolean().optional(),
});
exports.businessSettingsSchema = exports.updateBusinessSettingsRequestSchema.extend({
    id: exports.businessIdSchema,
    updatedAt: zod_1.z.string().datetime(),
});
exports.operationalLocationInputSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(2).max(120),
    addressLine1: zod_1.z.string().trim().min(3).max(160),
    addressLine2: nullableTrimmedString(160),
    city: zod_1.z.string().trim().min(2).max(100),
    state: zod_1.z
        .string()
        .trim()
        .transform((value) => value.toUpperCase())
        .pipe(zod_1.z.string().regex(/^[A-Z]{2}$/, "Use a two-letter US state code.")),
    postalCode: zod_1.z
        .string()
        .trim()
        .regex(/^\d{5}(?:-\d{4})?$/, "Use a valid US ZIP code."),
    timezone: timeZoneSchema,
});
exports.createOperationalLocationRequestSchema = exports.operationalLocationInputSchema;
exports.updateOperationalLocationRequestSchema = exports.operationalLocationInputSchema;
exports.operationalLocationSchema = exports.operationalLocationInputSchema.extend({
    id: exports.operationalLocationIdSchema,
    country: zod_1.z.literal("US"),
    status: exports.operationalLocationStatusSchema,
    isDefault: zod_1.z.boolean(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.operationalLocationListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.operationalLocationSchema),
});
exports.businessContextSchema = zod_1.z.object({
    actor: zod_1.z.object({
        userId: zod_1.z.string().uuid(),
        email: zod_1.z.string().email().nullable(),
        displayName: zod_1.z.string().nullable(),
    }),
    tenant: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        displayName: zod_1.z.string().min(1).max(120),
        status: zod_1.z.enum(["ACTIVE", "ARCHIVED"]),
        isPrimary: zod_1.z.boolean(),
    }),
    organization: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        displayName: zod_1.z.string().min(1).max(120),
    }),
    membership: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        role: exports.membershipRoleSchema,
    }),
    business: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        name: zod_1.z.string(),
        logoUrl: zod_1.z.string().url().nullable(),
        legalName: zod_1.z.string().nullable(),
        contactEmail: zod_1.z.string().email().nullable(),
        phone: zod_1.z.string().nullable(),
        currency: zod_1.z.literal("USD"),
        defaultTimezone: zod_1.z.string(),
        multiLocationEnabled: zod_1.z.boolean().optional(),
    }),
    location: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        name: zod_1.z.string(),
        addressLine1: zod_1.z.string(),
        addressLine2: zod_1.z.string().nullable(),
        city: zod_1.z.string(),
        state: zod_1.z.string().length(2),
        postalCode: zod_1.z.string(),
        country: zod_1.z.literal("US"),
        timezone: zod_1.z.string(),
        isDefault: zod_1.z.boolean(),
    }),
    availableLocations: zod_1.z.array(exports.operationalLocationAccessSchema).min(1),
    activeScope: zod_1.z.object({
        tenantId: zod_1.z.string().uuid(),
        businessId: exports.businessIdSchema,
        locationId: exports.operationalLocationIdSchema,
        kind: zod_1.z.literal("OPERATIONAL_LOCATION"),
    }),
});
exports.currentBusinessContextResponseSchema = zod_1.z.object({
    context: exports.businessContextSchema.nullable(),
});
exports.workspaceAccessSchema = zod_1.z.object({
    organizationId: zod_1.z.string().uuid(),
    organizationName: zod_1.z.string().min(1).max(120),
    tenantId: zod_1.z.string().uuid(),
    tenantName: zod_1.z.string().min(1).max(120),
    businessId: exports.businessIdSchema,
    businessName: zod_1.z.string().min(1).max(120),
    multiLocationEnabled: zod_1.z.boolean().optional(),
    role: exports.membershipRoleSchema,
    isDefault: zod_1.z.boolean(),
    isPrimary: zod_1.z.boolean(),
    locations: zod_1.z.array(exports.operationalLocationAccessSchema).min(1),
});
exports.workspaceAccessListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.workspaceAccessSchema),
});
exports.mobileBusinessAccessSchema = zod_1.z.object({
    organizationId: zod_1.z.string().uuid(),
    organizationName: zod_1.z.string().min(1).max(120),
    tenantId: zod_1.z.string().uuid(),
    businessId: exports.businessIdSchema,
    businessName: zod_1.z.string().min(1),
    businessLogoUrl: zod_1.z.string().url().nullable(),
    multiLocationEnabled: zod_1.z.boolean().optional(),
    membershipId: zod_1.z.string().uuid(),
    role: exports.membershipRoleSchema,
    permissions: zod_1.z.array(exports.mobileStaffPermissionSchema),
    capabilities: zod_1.z.array(staff_capability_1.staffCapabilitySchema),
    isDefault: zod_1.z.boolean(),
    timezone: timeZoneSchema,
    defaultLocation: zod_1.z.object({
        id: exports.operationalLocationIdSchema,
        name: zod_1.z.string().min(1),
        timezone: timeZoneSchema,
    }),
    activeLocation: exports.operationalLocationAccessSchema,
    locations: zod_1.z.array(exports.operationalLocationAccessSchema).min(1),
});
exports.mobileBootstrapResponseSchema = zod_1.z.object({
    identity: zod_1.z.object({
        userId: zod_1.z.string().uuid().nullable(),
        email: zod_1.z.string().email().nullable(),
        displayName: zod_1.z.string().nullable(),
    }),
    memberships: zod_1.z.array(exports.mobileBusinessAccessSchema),
    activeBusiness: exports.mobileBusinessAccessSchema.nullable(),
});
function isValidTimeZone(value) {
    try {
        new Intl.DateTimeFormat("en-US", { timeZone: value }).format();
        return true;
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=business.js.map